import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {isNullOrUndefined} from 'util';
import {TravelCreditType} from '../../shared/models/travel-credit-type';
import {TravelCreditAction} from '../../shared/models/travel-credit-action';
import {NavigationService} from '../../shared/services/navigation.service';

@Component({
  selector: 'app-base-step',
  template: `<div>base</div>`
})
export class BaseStepComponent {

  public travelCreditType: TravelCreditType = null;
  public travelCreditAction: TravelCreditAction = null;
  public stepNumber;
  public navigationService: NavigationService;
  public router: Router;
  public previousStep;
  public nextStep;

  constructor(private route: ActivatedRoute, navigationService: NavigationService, router: Router) {
    this.navigationService = navigationService
    this.router = router;

    let self = this;
    self.route.parent.data.subscribe(val => {
      if (val) {
        if (val.travelCreditType) {
          self.travelCreditType = val.travelCreditType;
        }
        if (TravelCreditAction[val.travelCreditAction]) {
          self.travelCreditAction = val.travelCreditAction;
        }
      }
    });

    if (self.route && self.route.data) {
      self.route.data.subscribe(val => {
        if (val) {
          if (val.stepNumber) {
            this.stepNumber = val.stepNumber;
            this.navigationService.publishStepChanged(val.stepNumber);
          }
          if (val.previousStep) {
            this.previousStep = val.previousStep;
          }
          if (val.nextStep) {
            this.nextStep = val.nextStep;
          }
        }
      });
    }
  }


  get canMovePrevious(): boolean {
    return !isNullOrUndefined(this.previousStep);
  }

  movePrevious() {
    if (this.previousStep) {
      this.router.navigate([this.previousStep], { relativeTo: this.route });
    }
  }

  moveNext() {
    if (this.nextStep) {
      this.router.navigate([this.nextStep], { relativeTo: this.route });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/steps/base-step/base-step.component.ts